import { mode } from '@chakra-ui/theme-tools';

export const checkboxStyles = {
  components: {
    Checkbox: {
      baseStyle: (props: any) => ({
        control: {
          _invalid: {
            borderColor: mode('red.600', 'red.600')(props),
          },
          _disabled: {
            bg: mode('gray.100', 'whiteAlpha.100')(props),
            borderColor: mode('gray.300', 'whiteAlpha.300')(props),
            opacity: 0.8,
          },
          _checked: {
            _disabled: {
              bg: mode('brand.500', 'brand.400')(props),
              borderColor: mode('brand.500', 'brand.400')(props),
              color: mode('white', 'white')(props),
              opacity: 0.6,
            },
          },
        },
        label: {
          _disabled: {
            opacity: 0.8,
          },
        },
      }),
    },
  },
};
